// extracted by mini-css-extract-plugin
export var hidden = "_q1-1";
export var visible = "_q1-0";